import React, { useState, useEffect, useCallback } from 'react';
import { MainLayout } from '@/components/Layout';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

function money(v) {
  return 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function formatDate(iso) {
  if (!iso) return '-';
  const raw = String(iso).replace(' ', 'T');
  const d = new Date(raw.endsWith('Z') ? raw : raw + 'Z');
  return d.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' }) + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' });
}

const TIPO_CONFIG = {
  ENTREGA:   { label: 'Entrega',   color: '#16A34A', bg: '#F0FDF4', icon: '↗' },
  COD:       { label: 'COD',       color: '#DC2626', bg: '#FEF2F2', icon: '↙' },
  REPASSE:   { label: 'Repasse',   color: '#2563EB', bg: '#EFF6FF', icon: '↙' },
  TAXA_PAGA: { label: 'Taxa Paga', color: '#0891B2', bg: '#ECFEFF', icon: '✓' },
  AJUSTE:    { label: 'Ajuste',    color: '#7C3AED', bg: '#F5F3FF', icon: '↔' },
};

function getAuth() {
  const token = localStorage.getItem('token') || localStorage.getItem('access_token');
  return { headers: { Authorization: `Bearer ${token}` } };
}

// ==================== KPI CARD ====================
function KpiCard({ label, value, color, icon }) {
  return (
    <div data-testid={`kpi-${label.toLowerCase().replace(/\s/g,'-')}`} style={{
      background: '#fff', borderRadius: 12, padding: '18px 20px', flex: 1, minWidth: 150,
      boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #F1F5F9',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
        <div style={{
          width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: color + '18', color: color, fontSize: 16, fontWeight: 700,
        }}>{icon}</div>
        <span style={{ fontSize: 12, color: '#64748B', fontWeight: 500 }}>{label}</span>
      </div>
      <div style={{ fontSize: 22, fontWeight: 700, color: '#1E293B' }}>{value}</div>
    </div>
  );
}

// ==================== MODAL REPASSE ====================
function ModalRepasse({ motoboy, onClose, onSuccess }) {
  const [valor, setValor] = useState('');
  const [referencia, setReferencia] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!valor || Number(valor) <= 0) return alert('Valor deve ser positivo');
    setLoading(true);
    try {
      await axios.post(`${API}/motoboy-ledger/repasse`, {
        motoboy_id: motoboy.motoboy_id, valor: Number(valor), referencia: referencia || 'Repasse manual',
      }, getAuth());
      onSuccess();
    } catch (e) {
      alert('Erro: ' + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="modal-repasse" style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 999,
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: 28, width: 420, maxWidth: '90vw',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
      }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1E293B' }}>
          Registrar Repasse
        </h3>
        <p style={{ margin: '6px 0 20px', fontSize: 14, color: '#64748B' }}>
          Motoboy: <strong>{motoboy.motoboy_nome}</strong> | Saldo: <strong style={{ color: motoboy.saldo < 0 ? '#DC2626' : '#16A34A' }}>{money(motoboy.saldo)}</strong>
        </p>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Valor do Repasse (R$)</label>
          <input data-testid="repasse-valor" type="number" step="0.01" min="0.01" value={valor} onChange={e => setValor(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 16, outline: 'none', boxSizing: 'border-box' }}
            placeholder="0,00" autoFocus />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Referencia</label>
          <input data-testid="repasse-referencia" type="text" value={referencia} onChange={e => setReferencia(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
            placeholder="Ex: PIX recebido, Dinheiro entregue..." />
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #D1D5DB', background: '#fff', color: '#374151', fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>Cancelar</button>
          <button data-testid="repasse-confirmar" onClick={submit} disabled={loading}
            style={{ padding: '10px 24px', borderRadius: 8, border: 'none', background: '#2563EB', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: 14, opacity: loading ? 0.6 : 1 }}>
            {loading ? 'Processando...' : 'Confirmar Repasse'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ==================== MODAL TAXA PAGA ====================
function ModalTaxaPaga({ motoboy, onClose, onSuccess }) {
  const [valor, setValor] = useState('');
  const [referencia, setReferencia] = useState('Pgto taxa entrega');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!valor || Number(valor) <= 0) return alert('Valor deve ser positivo');
    setLoading(true);
    try {
      await axios.post(`${API}/motoboy-ledger/taxa-paga`, {
        motoboy_id: motoboy.motoboy_id, valor: Number(valor), referencia,
      }, getAuth());
      onSuccess();
    } catch (e) {
      alert('Erro: ' + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="modal-taxa-paga" style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 999,
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: 28, width: 420, maxWidth: '90vw',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
      }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1E293B' }}>Pagar Taxa de Entrega</h3>
        <p style={{ margin: '6px 0 20px', fontSize: 14, color: '#64748B' }}>
          Motoboy: <strong>{motoboy.motoboy_nome}</strong> | Saldo: <strong style={{ color: motoboy.saldo < 0 ? '#DC2626' : '#16A34A' }}>{money(motoboy.saldo)}</strong>
        </p>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Valor da Taxa (R$)</label>
          <input data-testid="taxa-paga-valor" type="number" step="0.01" min="0.01" value={valor} onChange={e => setValor(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 16, outline: 'none', boxSizing: 'border-box' }}
            placeholder="Ex: 31.11" autoFocus />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Referencia</label>
          <input data-testid="taxa-paga-referencia" type="text" value={referencia} onChange={e => setReferencia(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
            placeholder="Ex: Pgto semanal taxa..." />
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #D1D5DB', background: '#fff', color: '#374151', fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>Cancelar</button>
          <button data-testid="taxa-paga-confirmar" onClick={submit} disabled={loading}
            style={{ padding: '10px 24px', borderRadius: 8, border: 'none', background: '#0891B2', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: 14, opacity: loading ? 0.6 : 1 }}>
            {loading ? 'Processando...' : 'Confirmar Pagamento'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ==================== MODAL AJUSTE ====================
function ModalAjuste({ motoboy, onClose, onSuccess }) {
  const [valor, setValor] = useState('');
  const [referencia, setReferencia] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!valor || Number(valor) === 0) return alert('Valor nao pode ser zero');
    setLoading(true);
    try {
      await axios.post(`${API}/motoboy-ledger/ajuste`, {
        motoboy_id: motoboy.motoboy_id, valor: Number(valor), referencia: referencia || 'Ajuste manual',
      }, getAuth());
      onSuccess();
    } catch (e) {
      alert('Erro: ' + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="modal-ajuste" style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 999,
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: 28, width: 420, maxWidth: '90vw',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
      }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1E293B' }}>Registrar Ajuste</h3>
        <p style={{ margin: '6px 0 20px', fontSize: 14, color: '#64748B' }}>
          Motoboy: <strong>{motoboy.motoboy_nome}</strong>
        </p>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Valor (positivo = credito, negativo = debito)</label>
          <input data-testid="ajuste-valor" type="number" step="0.01" value={valor} onChange={e => setValor(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 16, outline: 'none', boxSizing: 'border-box' }}
            placeholder="Ex: 10.00 ou -5.00" autoFocus />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 }}>Motivo</label>
          <input data-testid="ajuste-referencia" type="text" value={referencia} onChange={e => setReferencia(e.target.value)}
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
            placeholder="Ex: Bonus, Desconto gasolina..." />
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #D1D5DB', background: '#fff', color: '#374151', fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>Cancelar</button>
          <button data-testid="ajuste-confirmar" onClick={submit} disabled={loading}
            style={{ padding: '10px 24px', borderRadius: 8, border: 'none', background: '#7C3AED', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: 14, opacity: loading ? 0.6 : 1 }}>
            {loading ? 'Processando...' : 'Confirmar Ajuste'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ==================== EXTRATO PANEL ====================
function ExtratoPanel({ motoboy, onClose }) {
  const [movs, setMovs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saldo, setSaldo] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const r = await axios.get(`${API}/motoboy-ledger/extrato/${motoboy.motoboy_id}`, getAuth());
        setMovs(r.data.movimentacoes || []);
        setSaldo(r.data.saldo || 0);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetch();
  }, [motoboy.motoboy_id]);

  let saldoRunning = 0;
  const movsReversed = [...movs].reverse();
  const movsWithSaldo = movsReversed.map(m => {
    saldoRunning += m.valor;
    return { ...m, saldo_acumulado: saldoRunning };
  }).reverse();

  return (
    <div data-testid="extrato-panel" style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex',
      justifyContent: 'flex-end', zIndex: 999,
    }} onClick={onClose}>
      <div style={{
        background: '#fff', width: 560, maxWidth: '95vw', height: '100vh', overflowY: 'auto',
        boxShadow: '-10px 0 40px rgba(0,0,0,0.15)', padding: 0,
      }} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ background: '#1E293B', padding: '24px 28px', color: '#fff' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h3 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>Extrato Financeiro</h3>
              <p style={{ margin: '4px 0 0', fontSize: 14, opacity: 0.7 }}>{motoboy.motoboy_nome} | {motoboy.motoboy_phone}</p>
            </div>
            <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', width: 36, height: 36, borderRadius: 8, cursor: 'pointer', fontSize: 18 }}>✕</button>
          </div>
          <div style={{ marginTop: 16, display: 'flex', gap: 16 }}>
            <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 18px', flex: 1 }}>
              <div style={{ fontSize: 11, opacity: 0.6, marginBottom: 2 }}>SALDO ATUAL</div>
              <div style={{ fontSize: 24, fontWeight: 700, color: saldo < 0 ? '#FCA5A5' : '#86EFAC' }}>{money(saldo)}</div>
            </div>
            <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 18px', flex: 1 }}>
              <div style={{ fontSize: 11, opacity: 0.6, marginBottom: 2 }}>ENTREGAS</div>
              <div style={{ fontSize: 24, fontWeight: 700 }}>{motoboy.total_entregas}</div>
            </div>
          </div>
        </div>

        {/* Movimentacoes */}
        <div style={{ padding: '20px 28px' }}>
          <h4 style={{ margin: '0 0 14px', fontSize: 14, fontWeight: 600, color: '#64748B', textTransform: 'uppercase', letterSpacing: 1 }}>Movimentacoes</h4>
          {loading ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#94A3B8' }}>Carregando...</div>
          ) : movs.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#94A3B8' }}>Nenhuma movimentacao registrada</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {movsWithSaldo.map((m, i) => {
                const cfg = TIPO_CONFIG[m.tipo] || TIPO_CONFIG.AJUSTE;
                return (
                  <div key={m.id} data-testid={`mov-${i}`} style={{
                    display: 'flex', alignItems: 'center', padding: '12px 14px', borderRadius: 8,
                    background: i % 2 === 0 ? '#FAFBFC' : '#fff', gap: 12,
                  }}>
                    <div style={{
                      width: 36, height: 36, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: cfg.bg, color: cfg.color, fontSize: 16, fontWeight: 700, flexShrink: 0,
                    }}>{cfg.icon}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#1E293B' }}>{cfg.label}</div>
                      <div style={{ fontSize: 12, color: '#94A3B8', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {m.referencia || '-'} | {formatDate(m.created_at)}
                      </div>
                    </div>
                    <div style={{ textAlign: 'right', flexShrink: 0 }}>
                      <div style={{ fontSize: 15, fontWeight: 700, color: m.valor >= 0 ? '#16A34A' : '#DC2626' }}>
                        {m.valor >= 0 ? '+' : ''}{money(m.valor)}
                      </div>
                      <div style={{ fontSize: 11, color: '#94A3B8' }}>Saldo: {money(m.saldo_acumulado)}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ==================== MAIN PAGE ====================
export function MotoboyLedgerPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalRepasse, setModalRepasse] = useState(null);
  const [modalTaxaPaga, setModalTaxaPaga] = useState(null);
  const [modalAjuste, setModalAjuste] = useState(null);
  const [extrato, setExtrato] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/motoboy-ledger/saldos`, getAuth());
      setData(r.data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const totals = data.reduce((acc, m) => ({
    saldo: acc.saldo + m.saldo,
    entregas: acc.entregas + m.total_entregas,
    taxas: acc.taxas + m.total_taxas,
    cod: acc.cod + m.total_cod,
    repasses: acc.repasses + m.total_repasses,
  }), { saldo: 0, entregas: 0, taxas: 0, cod: 0, repasses: 0 });

  const handleRepasseSuccess = () => { setModalRepasse(null); fetchData(); };
  const handleTaxaPagaSuccess = () => { setModalTaxaPaga(null); fetchData(); };
  const handleAjusteSuccess = () => { setModalAjuste(null); fetchData(); };

  return (
    <MainLayout>
      <div data-testid="motoboy-ledger-page" style={{ maxWidth: 1200, margin: '0 auto', padding: '24px 16px' }}>
        {/* Header */}
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ margin: 0, fontSize: 28, fontWeight: 800, color: '#1E293B', fontFamily: "'Barlow Condensed', sans-serif" }}>
            Financeiro Motoboys
          </h1>
          <p style={{ margin: '4px 0 0', fontSize: 14, color: '#64748B' }}>
            Controle de saldos, entregas, COD e repasses
          </p>
        </div>

        {/* KPIs */}
        <div style={{ display: 'flex', gap: 14, marginBottom: 24, flexWrap: 'wrap' }}>
          <KpiCard label="Saldo Total" value={money(totals.saldo)} color={totals.saldo < 0 ? '#DC2626' : '#16A34A'} icon="$" />
          <KpiCard label="Entregas" value={totals.entregas} color="#F59E0B" icon="E" />
          <KpiCard label="Taxas Ganhas" value={money(totals.taxas)} color="#16A34A" icon="+" />
          <KpiCard label="COD Recebido" value={money(totals.cod)} color="#DC2626" icon="-" />
          <KpiCard label="Repasses" value={money(totals.repasses)} color="#2563EB" icon="R" />
        </div>

        {/* Table */}
        <div style={{
          background: '#fff', borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          border: '1px solid #F1F5F9', overflow: 'hidden',
        }}>
          <table data-testid="motoboy-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#F8FAFC' }}>
                {['MOTOBOY','CONTATO','ENTREGAS','TAXAS','COD','REPASSES','SALDO','ACOES'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', fontSize: 11, fontWeight: 600, color: '#64748B', textAlign: 'left', letterSpacing: 0.5, borderBottom: '1px solid #E2E8F0' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: '#94A3B8' }}>Carregando...</td></tr>
              ) : data.length === 0 ? (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: '#94A3B8' }}>Nenhum motoboy encontrado</td></tr>
              ) : data.map((m, i) => (
                <tr key={m.motoboy_id} data-testid={`row-${m.motoboy_nome}`} style={{ borderBottom: '1px solid #F1F5F9', background: i % 2 === 0 ? '#fff' : '#FAFBFC' }}>
                  <td style={{ padding: '14px 16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{
                        width: 36, height: 36, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: '#FEE2E2', color: '#DC2626', fontSize: 14, fontWeight: 700,
                      }}>{m.motoboy_nome[0]}</div>
                      <div>
                        <div style={{ fontWeight: 600, color: '#1E293B', fontSize: 14 }}>{m.motoboy_nome}</div>
                        <div style={{ fontSize: 11, color: m.is_active ? '#16A34A' : '#94A3B8' }}>{m.is_active ? 'Ativo' : 'Inativo'}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: '14px 16px', fontSize: 13, color: '#475569' }}>{m.motoboy_phone}</td>
                  <td style={{ padding: '14px 16px', fontSize: 14, fontWeight: 600, color: '#1E293B', textAlign: 'center' }}>{m.total_entregas}</td>
                  <td style={{ padding: '14px 16px', fontSize: 13, color: '#16A34A', fontWeight: 600 }}>{money(m.total_taxas)}</td>
                  <td style={{ padding: '14px 16px', fontSize: 13, color: '#DC2626', fontWeight: 600 }}>{money(m.total_cod)}</td>
                  <td style={{ padding: '14px 16px', fontSize: 13, color: '#2563EB', fontWeight: 600 }}>{money(m.total_repasses)}</td>
                  <td style={{ padding: '14px 16px' }}>
                    <span style={{
                      fontSize: 15, fontWeight: 700,
                      color: m.saldo < 0 ? '#DC2626' : m.saldo > 0 ? '#16A34A' : '#64748B',
                    }}>{money(m.saldo)}</span>
                  </td>
                  <td style={{ padding: '14px 16px' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button data-testid={`btn-extrato-${m.motoboy_nome}`} onClick={() => setExtrato(m)} title="Extrato"
                        style={{ width: 32, height: 32, borderRadius: 6, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F0FDF4', color: '#16A34A', fontSize: 14, fontWeight: 700 }}>
                        E
                      </button>
                      <button data-testid={`btn-repasse-${m.motoboy_nome}`} onClick={() => setModalRepasse(m)} title="Repasse (motoboy entrega COD à loja)"
                        style={{ width: 32, height: 32, borderRadius: 6, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#EFF6FF', color: '#2563EB', fontSize: 14, fontWeight: 700 }}>
                        R
                      </button>
                      <button data-testid={`btn-taxa-paga-${m.motoboy_nome}`} onClick={() => setModalTaxaPaga(m)} title="Pagar Taxa de Entrega ao Motoboy"
                        style={{ width: 32, height: 32, borderRadius: 6, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ECFEFF', color: '#0891B2', fontSize: 14, fontWeight: 700 }}>
                        T
                      </button>
                      <button data-testid={`btn-ajuste-${m.motoboy_nome}`} onClick={() => setModalAjuste(m)} title="Ajuste manual"
                        style={{ width: 32, height: 32, borderRadius: 6, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5F3FF', color: '#7C3AED', fontSize: 14, fontWeight: 700 }}>
                        A
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modals */}
      {modalRepasse && <ModalRepasse motoboy={modalRepasse} onClose={() => setModalRepasse(null)} onSuccess={handleRepasseSuccess} />}
      {modalTaxaPaga && <ModalTaxaPaga motoboy={modalTaxaPaga} onClose={() => setModalTaxaPaga(null)} onSuccess={handleTaxaPagaSuccess} />}
      {modalAjuste && <ModalAjuste motoboy={modalAjuste} onClose={() => setModalAjuste(null)} onSuccess={handleAjusteSuccess} />}
      {extrato && <ExtratoPanel motoboy={extrato} onClose={() => setExtrato(null)} />}
    </MainLayout>
  );
}

export default MotoboyLedgerPage;
